import { useEffect, useState } from 'react';

function AuthLayout({ children }) {
    const [loading, setLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => setLoading(false), 300);
        }, 600);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div
            className="relative overflow-hidden bg-cover before:content-[''] before:absolute before:inset-0 before:bg-primary before:-z-[1]"
            style={{ backgroundImage: "url('/assets/img/login-bg.png')" }}
        >
            {loading ? (
                <div
                    className={`fixed left-0 top-0 z-[999999] flex h-screen w-screen items-center justify-center bg-white transition-opacity duration-300 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
                >
                    <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-secondary border-t-transparent"></div>
                </div>
            ) : (
                <div className="relative px-4 sm:px-8 flex h-screen flex-col items-center justify-center overflow-hidden">
                    <div className="no-scrollbar overflow-y-auto w-full py-10 lg:py-14 2xl:py-20">{children}</div>

                    <footer
                        className="absolute bottom-0 left-0 right-0 h-16 border-t border-sky-100 border-opacity-30 from-black to-tertiary"
                        style={{ backgroundImage: 'linear-gradient(45deg, var(--tw-gradient-stops))' }}
                    >
                        <div className="container max-w-large h-full">
                            <div className="flex h-full items-center justify-between max-sm:flex-col max-sm:py-2">
                                <span className="text-[10px] text-white opacity-50">© Rometal {new Date().getFullYear()}. Todos os direitos reservados.</span>
                                <span className="flex gap-3 items-center text-[10px] text-white opacity-50">
                                    Desenvolvido por:
                                    <img src={`/assets/img/8poroito-logo.png`} alt="logo autor" className="w-[70px]" />
                                </span>
                            </div>
                        </div>
                    </footer>
                </div>
            )}
        </div>
    );
}

export default AuthLayout;
